import EdlioApiException from '../../edlio-js/exceptions/EdlioApiException';

/**
 * Fetch that checks for expected statuses before trying to parse JSON. If an
 * unexpected status is found, throw an EdlioApiException exception.
 *
 * @param {string} url for fetching
 * @param {number[]} expectedStatuses
 * @param {Object} fetchOptions
 * @param {boolean} displayLoginModal
 * @returns {Object} response object in json
 * @throws {EdlioApiException} ideally caught/reported by Sentry
 */
export default async function fetchAndCheckStatus (url, expectedStatuses = [ 200 ], fetchOptions = {}, displayLoginModal = true) {
  fetchOptions.headers = { ...fetchOptions.headers, Accept: 'application/json' };

  const res = await fetch(url, fetchOptions);

  if (!expectedStatuses.includes(res.status)) {
    // Unauthorized or session expired
    if (displayLoginModal && res.status === 401) {
      /**
       * Triggers login modal to show. See:
       * tomcat/apps/js/common/session_alert.js
       */
      const event = new Event('showLoginModal');
      document.dispatchEvent(event);
    }

    const message = res.statusText || await res.text();

    throw new EdlioApiException(message, res);
  } else {
    /*
     * You cannot read a response stream twice.
     * If res.json() throws an error (res body is not json)
     * we need an identical response copy available for a "second" resCopy.text() read
     */
    const resCopy = res.clone()

    try {
      return await res.json();
    } catch (e) {
      return await resCopy.text();
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-js/utils/fetchAndCheckStatus.js